import styled from 'styled-components'

export const SettingsWrapper = styled.div`
  & > div:first-child {
    .row {
      &:first-child {
        div[class^='col-'] {
          div {
            margin-bottom: 25px;
          }
        }
      }

      div[class^='col-'] {
        div {
          position: relative;
          display: block;
          float: left;

          &:first-child {
            margin-right: 25px;
          }
        }
      }
    }
  }
`
